import {
  HTTP_INTERCEPTORS,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import {
  CSRF_HEADER,
  readCsrfTokenFromCookie,
} from "./xsrf.util";

const MUTATING_METHODS = new Set(["POST", "PUT", "PATCH", "DELETE"]);


@Injectable()
export class XsrfInterceptor implements HttpInterceptor {
  intercept(
    req: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    if (!MUTATING_METHODS.has(req.method.toUpperCase())) {
      return next.handle(req);
    }

    const token = readCsrfTokenFromCookie();
    if (!token) {
      return next.handle(req);
    }

    return next.handle(
      req.clone({
        headers: req.headers.set(CSRF_HEADER, token),
      })
    );
  }
}

export const xsrfInterceptorProviders = [
  { provide: HTTP_INTERCEPTORS, useClass: XsrfInterceptor, multi: true },
];
